export default __webpack_public_path__ + "static/media/the_hermit.7ab56df2.png";